/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { getCartQty } from "@/query/getCartQty";
import { getComponentElements } from "@/utils/dom/component";

let instance: CartQuantity;

export function setCartQuantity(value: number) {
    instance?.setQuantity(value);
}

export function initCartQuantity() {
    const elements = getComponentElements(CartQuantity.selector);
    if (elements.length) {
        if (!instance) {
            instance = new CartQuantity(elements);
        } else {
            instance.addElements(elements);
        }
    }
}

export class CartQuantity {
    static selector = 'cart-quantity';

    public elements: HTMLElement[];
    public quantity: number = 0;

    constructor (elements: HTMLElement[]) {
        this.elements = elements;

        this.fetchQuantity();
    }

    /**
     * Destroy instance
     */
    public destroy(): void {
        instance = null as any;
        this.elements = null as any;
    }

    /**
     * Add additional elements to instance
     */
    public addElements(elements: HTMLElement[]): void {
        let added: boolean = false;

        elements.forEach(element => {
            if (!this.elements.includes(element)) {
                this.elements.push(element);
                added = true;
            }
        });

        if (added) {
            this.setQuantity(this.quantity);
        }
    }

    /**
     * Retrieve current qty
     */
    public getQuantity(): number {
        return this.quantity;
    }

    /**
     * Set cart quantity
     */
    public setQuantity(value: number): void {
        this.quantity = value;

        this.elements.forEach(element => {
            element.classList.toggle('empty', !value);
            element.textContent = "" + this.quantity;
        });
    }

    /**
     * Refresh quantity value from server
     */
    public refresh(): void {
        this.fetchQuantity();
    }

    /**
     * Fetch and update quantity
     */
    private fetchQuantity(): void {
        getCartQty().then(
            result => this.setQuantity(
                result.isOk() ? result.value.qty : 0
            )
        );
    }
}
